// extracted by mini-css-extract-plugin
export default {"root":"PrivilegeList__root--2KDRL","item":"PrivilegeList__item--1GCD9","icon":"PrivilegeList__icon--3YDcJ"};